import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const path = "/roadmap-stage";
export const organizationRoadmap = createCrudVuexModule({
  namespaced: true,
  path,
  state: {
    stages: [],
  },
  getters: {
    stages: (state) => state.stages,
  },
  mutations: {
    addStages: (state, value) => (state.stages = [...state.stages.filter((i) => i.definition != value.definition), value]),
  },
  actions: {
    async loadStage({ getters, rootGetters, commit, dispatch }, { stage, roadmap }) {
      try {
        const response = await rest.post(`${path}`, { roadmapDefinition: roadmap, definition: stage });
        commit("addStages", response.data);
        return response;
      } catch (e) {
        console.error(e);
      }
    },
  },
});
